import script from "./ServicerInterestDetailsCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServicerInterestDetailsCard.vue?vue&type=script&setup=true&lang=ts"

import "./ServicerInterestDetailsCard.vue?vue&type=style&index=0&id=76360391&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76360391"]])

export default __exports__